import { background, stroke, surface, text } from '@scaleaq/sui-tokens/colors';
import styled, { css } from 'styled-components';

import { StyledCardWrapperWithState } from '../styledCardWrapperWithState';

const transition = css`
  transition: all 0.5s ease-in-out;
`;
export const StyledSummaryCard = styled(StyledCardWrapperWithState)`
  position: relative;
  overflow: hidden;
  ${transition}
  .title {
    ${transition}
  }

  &.is-disabled {
    cursor: default;
    pointer-events: none;
  }

  .arrow-forward-icon {
    color: ${background.info.solid[100]};
    transform: translateX(0);
    ${transition}
  }

  .push-arrow {
    opacity: 0;
    color: ${text.neutral.on.soft.contrast[100]};
    transform: translateX(-40px);
    ${transition}
  }

  &:hover {
    background-color: ${background.action.soft[100]};
    ${transition}

    .title {
      color: ${text.neutral.on.soft.contrast[100]};
      ${transition}
    }

    .arrow-forward-icon {
      color: ${text.neutral.on.soft.contrast[100]};
      opacity: 0;
      transform: rotateX(100deg);

      transition:
        transform 0.2s ease 0.15s,
        color 0.2s ease 0.15s,
        opacity 0.2s ease 0.15s;
    }

    .push-arrow {
      color: ${text.neutral.on.soft.contrast[100]};
      opacity: 1;
      transform: translateX(-16px);
      ${transition}
    }
  }

  &.is-disabled:hover {
    cursor: default;
    background-color: ${surface.default};

    .title {
      color: ${text.info.on.soft[100]};
    }

    .arrow-forward-icon {
      color: ${background.info.solid[100]};
      opacity: 1;
      transform: translateX(0);
    }

    .push-arrow {
      opacity: 0;
      transform: translateX(-40px);
    }
  }
  &:focus,
  &:focus-visible {
    background-color: ${surface.sunken};
    outline: 2px solid ${stroke.focused};
    transition: outline 0s;
  }
`;
